import { FlamingoHttpService } from './flamingo-http.service';

export function initializeFlamingo(httpService: FlamingoHttpService): () => Promise<void> {
  return (): Promise<void> => {
    return new Promise((resolve, reject) => {
      console.log('Startup Flamingo Services');
      resolve();
    });
  };
}
